import axios from "axios";

const download = async (request, fileName) => {
  const res = await axios.get(request, {
    responseType: 'blob',
  });
  const url = URL.createObjectURL(res.data);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
} 

export const downloadCustomerTemplate = async () => {
  try {
    await download('/api/v1/importManagement/downloadCustomerTemplate', 'CustomerTemplate.xlsx');
  } catch {

  }
};

export const downloadProductTemplate = async () => {
    try {
      await download('/api/v1/importManagement/downloadProductTemplate', 'ProductTemplate.xlsx');
    } catch {
    
    }
  };

  export const downloadAddressTemplate = async () => {
    try {
      await download('/api/v1/importManagement/downloadAddressTemplate', 'AddressTemplate.xlsx');
    } catch {
      
    }
  };

  
  export const downloadUserTemplate = async () => {
    try {
      await download('/api/v1/importManagement/downloadUserTemplate', 'UserTemplate.xlsx');
    } catch {
      
    }
  };
